(function (window, document, cu) {
	"use strict";

	const _data = new WeakMap();
	const _listeners = new WeakMap();

	function getData(el) {
		return _data.get(el);
	}

	function setData(el, data) {
		_data.set(el, data);
	}

	function addListener(el, type, fn, ns) {
		el.addEventListener(type, fn);
		if (!_listeners.has(el)) _listeners.set(el, []);
		_listeners.get(el).push({ type, fn, ns });
	}

	function removeListenersByNs(el, ns) {
		if (!_listeners.has(el)) return;
		const remaining = [];
		for (const entry of _listeners.get(el)) {
			if (entry.ns === ns) {
				el.removeEventListener(entry.type, entry.fn);
			} else {
				remaining.push(entry);
			}
		}
		_listeners.set(el, remaining);
	}

	function outerHeight(el) {
		const s = getComputedStyle(el);
		return el.offsetHeight + parseInt(s.marginTop) + parseInt(s.marginBottom);
	}

	function outerWidth(el) {
		const s = getComputedStyle(el);
		return el.offsetWidth + parseInt(s.marginLeft) + parseInt(s.marginRight);
	}

	function clearMenuStyle(menuEl) {
		menuEl.classList.remove('iw-display', 'iw-opening', 'iw-type-default', 'iw-type-slidermenu');
		Object.assign(menuEl.style, { opacity: '0', left: '', top: '', bottom: '', width: '', height: '' });
	}

	function clearAllMenuStyles() {
		document.querySelectorAll('.iw-contextMenu').forEach(clearMenuStyle);
	}

	const state = {
		timer: null,
		resetTimer() {
			if (state.timer) {
				clearTimeout(state.timer);
				state.timer = null;
			}
		}
	};

	function scheduleDelay(caller, fn, timeout = 400) {
		state.resetTimer();
		state.timer = setTimeout(() => fn(caller), timeout);
	}

	function attachContextMenu(el, menuId, option) {
		option = optimizeOption(option);
		const options = Object.assign({}, contextMenuDefaults, option);
		if (!options.baseTrigger) options.baseTrigger = el;
		bind(el, menuId, options);
		return el;
	}

	window.attachContextMenu = attachContextMenu;

	const contextMenuDefaults = {
		triggerOn: 'click',
		displayAround: 'cursor',
		mouseClick: 'left',
		closeOther: true,
		closeOnResize: true,
		closeOnScroll: true,
		closeOnClick: false,
		closeOnClickSelector: null,
		type: 'default',
		delay: 0,
		beforeOpen: () => 0,
		onOpen: () => Promise.resolve(),
		onMouseLeave: () => {},
		beforeDisplay: () => 1,
		afterOpen: () => {},
		onClose: () => {}
	};

	function optimizeOption(option) {
		if (!option) return option;
		if (option.mouseClick === 'right' && option.triggerOn === 'click') {
			option.triggerOn = 'contextmenu';
		}
		return option;
	}

	function bind(triggerEl, menuId, option) {
		let menuEl = document.getElementById(menuId);

		if (!menuEl) {
			menuEl = triggerEl.querySelector('#' + menuId);
			if (!menuEl) return;
		}

		menuEl.classList.add('iw-contextMenu');
		setTimeout(() => menuEl.classList.add('iw-contextMenu-fixed'), 1);

		const baseTrigger = option.baseTrigger;
		let menuData = getData(menuEl);

		if (!menuData) {
			let id;
			const baseTriggerData = getData(baseTrigger);
			if (!baseTriggerData) {
				id = Math.ceil(Math.random() * 100000);
				setData(baseTrigger, { menuId: id });
			} else {
				id = baseTriggerData.menuId;
			}
			menuData = { menuId: id, noTrigger: 1, trigger: triggerEl, option };
			menuEl.setAttribute('menuId', id);
			setData(menuEl, menuData);
		} else {
			menuData.noTrigger++;
			setData(menuEl, menuData);
		}

		setData(triggerEl, { menuId: menuData.menuId, option, menu: menuEl, menuSelector: menuId });
		triggerEl.classList.add('iw-mTrigger');

		let triggerOn = option.triggerOn;
		if (triggerOn.includes('hover')) {
			triggerOn = triggerOn.replace('hover', 'mouseenter');

			if (baseTrigger === triggerEl && !option.closeOnClick) {
				const hoverOutHandler = (e) => {
					if (!e.relatedTarget?.closest('.iw-contextMenu')) {
						clearAllMenuStyles();
					}
				};
				addListener(baseTrigger, 'mouseleave', hoverOutHandler, 'contextMenu');
				addListener(menuEl, 'mouseleave', hoverOutHandler, 'contextMenu');
			}

			addListener(triggerEl, 'mouseleave', (e) => {
				const cbData = { trigger: triggerEl, menu: menuEl, options: option, state };
				option.onMouseLeave.call(triggerEl, cbData, e);
			}, 'contextMenu');
		}

		for (const type of triggerOn.split(' ')) {
			addListener(triggerEl, type, eventHandler, 'contextMenu');
		}

		addListener(menuEl, 'click', e => e.stopPropagation(), 'contextMenu');
		addListener(menuEl, 'mouseenter', e => e.stopPropagation(), 'contextMenu');

		if (option.closeOnClick) {
			addListener(menuEl, 'click', (e) => {
				let el = e.target;
				while (el && !(el instanceof HTMLBodyElement)) {
					if (el.classList.contains('iw-contextMenu')) break;
					if (el.classList.contains('iw-mTrigger')) return;
					el = el.parentNode;
				}
				const shouldClose = !option.closeOnClickSelector || option.closeOnClickSelector(e.target);
				if (shouldClose) closeContextMenu(option, triggerEl, menuEl, e);
			}, 'contextMenu');
		}
	}

	let _globalClickHandler = null;

	function eventHandler(e) {
		e.preventDefault();
		const triggerEl = this;
		const trgrData = getData(triggerEl);
		const menuEl = trgrData.menu;
		const menuData = getData(menuEl);
		const option = trgrData.option;
		const cbData = { trigger: triggerEl, menu: menuEl, options: option, state };

		const baseEl = option.baseTrigger || triggerEl;
		const res = option.beforeOpen.call(triggerEl, cbData, e);

		if (res !== 0 && res !== 1) return;

		if (res === 0) {
			if (option.closeOther) {
				document.querySelectorAll('.iw-contextMenu').forEach(m => { if (m !== menuEl) clearMenuStyle(m); });
			}
		} else {
			if (option.closeOther) clearAllMenuStyles();
			return;
		}

		menuEl.classList.add('iw-opening');

		const openMenu = () => {
			if (!menuEl.classList.contains('iw-opening')) return;

			const cHeight = window.innerHeight;
			const cWidth = window.innerWidth;
			let left = null, top = null;

			menuEl.classList.add('iw-type-' + option.type);

			if (!menuData.menuHeight) {
				const clone = menuEl.cloneNode(true);
				document.body.appendChild(clone);
				const h = clone.offsetHeight;
				clone.style.height = '1px';
				menuData.menuWidth = clone.offsetWidth;
				menuData.menuHeight = h;
				clone.parentNode.removeChild(clone);
				setData(menuEl, menuData);
			}

			const menuHeight = menuData.menuHeight;
			const menuWidth = menuData.menuWidth;

			if (option.displayAround === 'cursor') {
				left = e.clientX;
				top = e.clientY;
			} else if (option.displayAround.startsWith('trigger')) {
				const rect = baseEl.getBoundingClientRect();
				const parentOffset = cu.getParentOffset(baseEl);
				const triggerH = outerHeight(baseEl);
				const triggerW = outerWidth(baseEl);
				const triggerLeft = rect.left - parentOffset.left;
				const triggerTop = rect.top - parentOffset.top;

				if (option.displayAround === 'triggertop') {
					top = triggerTop - menuHeight;
					left = triggerLeft;
				} else if (option.displayAround === 'triggerleft') {
					top = triggerTop;
					left = triggerLeft - menuWidth;
				} else if (option.displayAround === 'triggerbottom') {
					top = triggerTop + triggerH;
					left = triggerLeft;
				} else if (option.displayAround === 'triggerright') {
					top = triggerTop;
					left = triggerLeft + triggerW;
				}
			}

			const styles = { opacity: '1' };

			if (top !== null) {
				if (top + menuHeight > cHeight && top - menuHeight >= 0) top -= menuHeight;
				styles.top = top + 'px';
			}
			if (left !== null) {
				if (left + menuWidth > cWidth && cWidth - menuWidth >= 0) left = cWidth - menuWidth - 1;
				styles.left = left + 'px';
			}
			styles.bottom = (top !== null && menuHeight > cHeight - top) ? '5px' : '';

			if (option.beforeDisplay.call(triggerEl, cbData, e) !== 1) {
				clearAllMenuStyles();
				return;
			}

			if (option.width === 'trigger') {
				styles.width = outerWidth(baseEl) + 'px';
			}

			menuEl.classList.remove('iw-opening');
			Object.assign(menuEl.style, styles);
			menuEl.classList.add('iw-display');

			option.baseTrigger.classList.add('iw-opened');
			option.afterOpen.call(triggerEl, cbData, e);

			document.documentElement.removeEventListener('click', _globalClickHandler);
			_globalClickHandler = (ev) => {
				if (triggerEl !== ev.target && !ev.target.closest('.iw-mTrigger')) {
					closeContextMenu(option, triggerEl, menuEl, ev);
				}
			};
			document.documentElement.addEventListener('click', _globalClickHandler);

			if (option.closeOnResize) {
				menuData._resizeHandler = () => closeContextMenu(option, triggerEl, menuEl, null);
				window.addEventListener('resize', menuData._resizeHandler);
				setData(menuEl, menuData);
			}

			if (option.closeOnScroll) {
				const scrollHandler = () => closeContextMenu(option, triggerEl, menuEl, null);
				menuData._scrollHandlers = [];
				let pn = menuEl.parentNode;
				while (pn) {
					pn.addEventListener('scroll', scrollHandler);
					menuData._scrollHandlers.push({ el: pn, fn: scrollHandler });
					pn = pn.parentNode;
				}
				setData(menuEl, menuData);
			}
		};

		if (option.delay > 0) {
			scheduleDelay(triggerEl, caller => option.onOpen.call(caller, cbData, e).then(openMenu), option.delay);
		} else {
			option.onOpen.call(triggerEl, cbData, e).then(openMenu);
		}
	}

	function closeContextMenu(option, triggerEl, menuEl, e) {
		document.documentElement.removeEventListener('click', _globalClickHandler);
		_globalClickHandler = null;

		const menuData = getData(menuEl);
		if (menuData) {
			if (menuData._resizeHandler) {
				window.removeEventListener('resize', menuData._resizeHandler);
				menuData._resizeHandler = null;
			}
			if (menuData._scrollHandlers) {
				for (const { el, fn } of menuData._scrollHandlers) {
					el.removeEventListener('scroll', fn);
				}
				menuData._scrollHandlers = [];
			}
			setData(menuEl, menuData);
		}

		clearAllMenuStyles();
		option.baseTrigger.classList.remove('iw-opened');

		option.onClose.call(null, { trigger: triggerEl, menu: menuEl, options: option }, e);
	}

})(window, document, commonUtils);
